const PromedioIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 48 48"><path fill="#FFC107" d="m21.2 44.8l-18-18c-1.6-1.6-1.6-4.1 0-5.7l18-18c1.6-1.6 4.1-1.6 5.7 0l18 18c1.6 1.6 1.6 4.1 0 5.7l-18 18c-1.6 1.6-4.2 1.6-5.7 0" /><g fill="#37474F"><circle cx="24" cy="24" r="2" /><circle cx="32" cy="24" r="2" /><circle cx="16" cy="24" r="2" /></g></svg>
    );
}

export default PromedioIcon;